let Helpers = {
  formatCurrency: function(value) {
    return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  getAddressComponent(item, info) {
    // Get address part for google map autocomplete such as city, state, zip
    return info.address_components.filter(part => {
      return part.types.includes(item)
    })
  }
};


export default Helpers;